'use strict';
define([], function() {
    function SinglePageBrowserController($scope) {}
    SinglePageBrowserController.$inject=['$scope'];
    return SinglePageBrowserController;
});
